import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MapPin",
  "use": "svg-icon-MapPin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"svg-icon-MapPin\"><path fill=\"#e00000\" d=\"M14.88 9.75l4.46-2.42c0 3.54-2.47 7.59-4.64 11.07L11 24l1.67-10.33 2.21-3.92z\" /><circle cx=\"12\" cy=\"7.33\" r=\"7.33\" fill=\"#f33\" /><circle cx=\"12\" cy=\"7.33\" r=\"3\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol